exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-nav-link{display:flex;flex-direction:row;align-items:center;padding:10px 15px;text-decoration:none}.top-nav-link__icon{margin-right:5px;width:15px}.top-nav-link__icon path{fill:var(--black)}.top-nav-link__text{white-space:nowrap;color:var(--black);font-size:var(--font-medium);font-weight:var(--font-weight-lighter)}", ""]);

// exports
